// Module
var code = "<div class=\"ToolBarPreview\"> <label> <i class=\"fa fa-th\" aria-hidden=\"true\"></i> <!-- ko text: GetControlTypeTranslatedName() --><!-- /ko --> </label> </div>";
// Exports
export default code;